import { PropertyFieldValueViewModel } from "../types/property-field-value.view-model";
import { PropertySectionViewModel } from "../types/property-section.view-model";
import { createDefaultSections } from "./create-default-property-fields-view-fields";
import { PropertyFieldApiPayload } from "./property-fields-transformer";

export const transformApiPayloadToViewModels = (
  apiPayload: PropertyFieldApiPayload[]
): {
  sections: PropertySectionViewModel[];
  values: PropertyFieldValueViewModel[];
} => {
  const values: PropertyFieldValueViewModel[] = apiPayload
    .filter(field => field.value)
    .map(field => ({
      id: field.value?.id ?? 0,
      data_key: field.data_key,
      value:
        field.value?.value && typeof field.value.value === "object" && "field" in field.value.value
          ? field.value.value.field
          : null,
    }));

  const sections = createDefaultSections(values);

  return { sections, values };
};
